import { useEffect, useState } from 'react';
import _ from 'lodash';

function getSize() {
  return {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    outerHeight: window.outerHeight,
    outerWidth: window.outerWidth,
  };
}

function useWindowSize() {
  let [windowSize, setWindowSize] = useState(getSize());
  let didCancel = false;

  function handleResize() {
    if (!didCancel) setWindowSize(getSize());
  }

  useEffect(() => {
    window.addEventListener('resize', _.debounce(handleResize, 50));
    return () => {
      window.removeEventListener('resize', handleResize);
      didCancel = true;
    };
  }, []);

  return windowSize;
}

export default useWindowSize;
